import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="px-6 md:px-12 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:w-2/5">
            <Link to="/" className="font-heading text-2xl font-bold whitespace-nowrap cursor-pointer">
              Litbuy<span className="text-primary-300">Spreadsheets</span>
            </Link>
            <p className="mt-4 text-primary-200/70 text-sm leading-relaxed max-w-sm">
              Your trusted resource for Litbuy Spreadsheet guides, tutorials, comparisons, and expert insights. Helping users make informed decisions about spreadsheet tools since 2026.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" aria-label="Twitter" className="w-9 h-9 flex items-center justify-center rounded-full border border-primary-600 text-primary-300 hover:text-background-50 hover:border-background-50 cursor-pointer transition-colors">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" aria-label="LinkedIn" className="w-9 h-9 flex items-center justify-center rounded-full border border-primary-600 text-primary-300 hover:text-background-50 hover:border-background-50 cursor-pointer transition-colors">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a href="#" aria-label="YouTube" className="w-9 h-9 flex items-center justify-center rounded-full border border-primary-600 text-primary-300 hover:text-background-50 hover:border-background-50 cursor-pointer transition-colors">
                <i className="ri-youtube-fill text-sm"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="font-heading text-base font-semibold mb-4">Quick Links</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-primary-200/70 text-sm hover:text-background-50 cursor-pointer transition-colors">Home</Link>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-primary-200/70 text-sm hover:text-background-50 cursor-pointer transition-colors">KA Spreadsheet Store</a>
                <Link to="/article/what-is-litbuy-spreadsheet" className="text-primary-200/70 text-sm hover:text-background-50 cursor-pointer transition-colors">Getting Started</Link>
              </div>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold mb-4">Resources</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/article/litbuy-spreadsheet-features" className="text-primary-200/70 text-sm hover:text-background-50 cursor-pointer transition-colors">Features</Link>
                <Link to="/article/litbuy-spreadsheet-benefits" className="text-primary-200/70 text-sm hover:text-background-50 cursor-pointer transition-colors">Benefits</Link>
                <Link to="/article/litbuy-spreadsheet-templates" className="text-primary-200/70 text-sm hover:text-background-50 cursor-pointer transition-colors">Templates</Link>
              </div>
            </div>
            <div>
              <h4 className="font-heading text-base font-semibold mb-4">Legal</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-primary-200/70 text-sm hover:text-background-50 cursor-pointer transition-colors">Privacy Policy</Link>
                <Link to="/" className="text-primary-200/70 text-sm hover:text-background-50 cursor-pointer transition-colors">Safety & Disclaimer</Link>
                <Link to="/" className="text-primary-200/70 text-sm hover:text-background-50 cursor-pointer transition-colors">Contact</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-700/60 px-6 md:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-primary-300/60 text-xs">
          &copy; 2026 LitbuySpreadsheets.buzz. All rights reserved. This is an independent educational resource.
        </p>
        <p className="text-primary-400/50 text-xs">
          Not affiliated with any specific spreadsheet brand.
        </p>
      </div>
    </footer>
  );
}